export default "__VITE_ASSET__DrzB8U_9__"